import { Procedure } from '../define-procedure';
import { Store, Actions } from '@ngxs/store';
import { RPCEvent } from '../define-event';
import { LabelsService } from 'src/app/story/labels.service';
import { getAnnotationEvents, getAnnotationProcedures} from './annotations';
import { AnnotationsIO } from '../models/annotations.io';
import { HotspotsIO } from '../models/hotspots.io';
import { getHotspotsProcedures, getHotspotsEvents } from './hotspots';
import { MessageEnum } from '../models/message.enum';
import { ToggleLabels } from 'src/app/engine/state/engine.actions';
import { HumanInterface } from '../models/human.interface';

interface SetLabelEnabled {
  enable: boolean;
}

type SetLabelEnabledRequest = SetLabelEnabled;
type SetLabelEnabledResponse = SetLabelEnabled;

type LabelsProcRequest = AnnotationsIO.AnnotationProcRequest | HotspotsIO.HotspotsProcRequest | SetLabelEnabledRequest;
type LabelsProcResponse = AnnotationsIO.AnnotationProcResponse | HotspotsIO.HotspotsProcResponse | SetLabelEnabledResponse;
type LabelsEventResponse = AnnotationsIO.AnnotationEventResponse | HotspotsIO.HotspotsEventResponse;

export function getLabelsEvents(human: HumanInterface, store: Store): RPCEvent<LabelsEventResponse>[] {
  return [
    // legacy: annotation events
    ...getAnnotationEvents(human, store),
    // legacy: hotspot events
    ...getHotspotsEvents(human, store)
  ];
}

export function getLabelsProcedures(
  Human: HumanInterface,
  store: Store,
  labelsService: LabelsService
): Procedure<LabelsProcRequest, LabelsProcResponse>[] {
  return [
    // legacy: annotation procedures
    ...getAnnotationProcedures(Human, store, labelsService),
    // legacy: hotspot procedures
    ...getHotspotsProcedures(Human, store, labelsService),
    // label procedures
    {
      procName: MessageEnum.LabelsSetEnabled,
      aliases: [MessageEnum.AnnotationsSetEnabled],
      actionFn: (params: SetLabelEnabledRequest) => {
        store.dispatch(new ToggleLabels(params.enable));
      }
    }
  ];
}
